import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = ["id", "aria-label", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "aria-expanded", "aria-controls", "aria-activedescendant", "disabled"]
const _hoisted_2 = { class: "app-select__value" }
const _hoisted_3 = ["name", "disabled", "required", "autocomplete"]
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id", "aria-label", "aria-labelledby"]
const _hoisted_7 = {
  key: 0,
  class: "app-select__group",
  role: "presentation"
}
const _hoisted_8 = ["id", "aria-selected", "disabled", "onPointermove", "onClick"]
const _hoisted_9 = { class: "app-select__option-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["app-select", { 'app-select--disabled': _ctx.disabled, 'app-select--invalid': _ctx.invalid }]),
    style: _normalizeStyle(_ctx.attrs.style),
    onFocusout: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args)))
  }, [
    _createElementVNode("button", {
      id: _ctx.id,
      ref: "trigger",
      class: "app-select__trigger",
      type: "button",
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-label": _ctx.attrs['aria-label'] || _ctx.inferredLabel || undefined,
      "aria-labelledby": _ctx.attrs['aria-labelledby'],
      "aria-describedby": _ctx.describedBy,
      "aria-required": _ctx.required || undefined,
      "aria-invalid": _ctx.invalid || undefined,
      "aria-expanded": _ctx.open,
      "aria-controls": _ctx.listId,
      "aria-activedescendant": _ctx.open && _ctx.activeIndex >= 0 ? _ctx.listId + '-' + _ctx.activeIndex : undefined,
      disabled: _ctx.disabled,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "selected", { option: _ctx.selected }, () => [
          _createElementVNode("span", null, _toDisplayString(_ctx.selected ? _ctx.selected.label : _ctx.placeholder), 1)
        ])
      ]),
      _createVNode(_component_icon, {
        class: "app-select__chevron",
        icon: "chevron-down",
        "aria-hidden": "true"
      })
    ], 40, _hoisted_1),
    _withDirectives(_createElementVNode("select", {
      ref: "native",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nativeValue) = $event)),
      class: "app-select__native",
      tabindex: "-1",
      "aria-hidden": "true",
      name: _ctx.name,
      disabled: _ctx.disabled,
      required: _ctx.required,
      autocomplete: _ctx.attrs.autocomplete,
      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onInvalid: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onInvalid && _ctx.onInvalid(...args)), ["prevent"]))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: String(option.value),
            value: option.value,
            disabled: option.disabled
          }, _toDisplayString(option.label), 9, _hoisted_4))
        }), 128))
      ])
    ], 40, _hoisted_3), [
      [_vModelSelect, _ctx.nativeValue]
    ]),
    (_ctx.invalid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          id: _ctx.listId + '-error',
          class: "app-select__error"
        }, _toDisplayString(_ctx.validationMessage), 9, _hoisted_5))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: _ctx.listId,
            ref: "menu",
            class: "app-select__menu",
            style: _normalizeStyle(_ctx.menuStyle),
            role: "listbox",
            "aria-label": _ctx.attrs['aria-label'] || _ctx.inferredLabel || undefined,
            "aria-labelledby": _ctx.attrs['aria-labelledby']
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (option, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (option.group && (index === 0 || _ctx.rows[index - 1].group !== option.group))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(option.group), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  id: _ctx.listId + '-' + index,
                  class: _normalizeClass(["app-select__option", { 'app-select__option--active': _ctx.activeIndex === index, 'app-select__option--grouped': !!option.group }]),
                  type: "button",
                  role: "option",
                  tabindex: "-1",
                  "aria-selected": _ctx.selectedIndex === index,
                  disabled: option.disabled,
                  onPointermove: ($event: any) => (!option.disabled && (_ctx.activeIndex = index)),
                  onPointerdown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                  onClick: ($event: any) => (_ctx.choose(index))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "option", { option: option }, () => [
                      _createElementVNode("span", null, _toDisplayString(option.label), 1)
                    ])
                  ]),
                  (_ctx.selectedIndex === index)
                    ? (_openBlock(), _createBlock(_component_icon, {
                        key: 0,
                        class: "app-select__check",
                        icon: "check",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_8)
              ], 64))
            }), 128))
          ], 12, _hoisted_6))
        : _createCommentVNode("", true)
    ]))
  ], 38))
}